// extracted by mini-css-extract-plugin
export default {"compare_button":"compare-button_compare_button__qMwVP"};